// Mock policy data for different insurance types
export const mockPolicies = [
  // Life Insurance Policy
  {
    id: 1,
    policy_name: "Comprehensive Life Protection Plan",
    slug: "comprehensive-life-protection-plan",
    short_description: "life_insurance",
    insurance_type: "life_insurance",
    policy_type: "life_insurance",
    description: "A comprehensive life insurance policy designed to provide financial security for your loved ones. This plan offers extensive coverage with flexible premium payment options and substantial death benefits to ensure your family's future is protected.",
    status: "pending",
    max_claims: 1,
    waiting_period: 90,
    geography: "National",
    provider_name: "SecureLife Insurance Ltd",
    provider_email: "contact@securelife.com",
    submitted_date: "2026-01-10T10:30:00Z",
    created_at: "2026-01-10T10:30:00Z",
    updated_at: "2026-01-10T10:30:00Z",
    coverage_durations: [
      {
        product_name: "Basic Life Cover",
        description: "Essential life coverage for individuals seeking affordable protection",
        duration: "10 years",
        premium: 500,
        premium_duration: "year",
        insurance_coverage_list: [
          { title: "Death Benefit", description: "Lump sum payment on death", limit: 100000 },
          { title: "Terminal Illness Benefit", description: "Early payout for terminal diagnosis", limit: 80000 },
          { title: "Accidental Death Benefit", description: "Additional coverage for accidental death", limit: 50000 }
        ],
        exclusions: [
          "Death within first 2 years due to suicide",
          "Death due to participation in criminal activities",
          "Pre-existing terminal conditions not disclosed"
        ],
        eligibility_criteria: [
          "Age between 18-65 years",
          "Pass medical examination",
          "Resident of Ghana"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Notify Insurer", description: "Contact us within 30 days of incident", timeframe: "Within 30 days" },
          { step_number: 2, title: "Submit Documents", description: "Provide death certificate and claim form", timeframe: "Within 60 days" },
          { step_number: 3, title: "Claim Review", description: "We review and verify all documents", timeframe: "14-21 days" },
          { step_number: 4, title: "Payment", description: "Benefit paid to beneficiaries", timeframe: "7-10 days after approval" }
        ],
        terms: "Full terms and conditions apply. Policy subject to underwriting approval."
      },
      {
        product_name: "Premium Life Shield",
        description: "Enhanced coverage with additional benefits for comprehensive protection",
        duration: "20 years",
        premium: 1200,
        premium_duration: "year",
        insurance_coverage_list: [
          { title: "Death Benefit", description: "Lump sum payment on death", limit: 250000 },
          { title: "Terminal Illness Benefit", description: "Early payout for terminal diagnosis", limit: 200000 },
          { title: "Accidental Death Benefit", description: "Additional coverage for accidental death", limit: 100000 },
          { title: "Critical Illness Rider", description: "Coverage for specified critical illnesses", limit: 50000 }
        ],
        exclusions: [
          "Death within first 2 years due to suicide",
          "Death due to participation in criminal activities",
          "Pre-existing terminal conditions not disclosed",
          "Death from self-inflicted injuries"
        ],
        eligibility_criteria: [
          "Age between 18-60 years",
          "Pass comprehensive medical examination",
          "Resident of Ghana",
          "No history of critical illness in past 5 years"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Notify Insurer", description: "Contact us within 30 days of incident", timeframe: "Within 30 days" },
          { step_number: 2, title: "Submit Documents", description: "Provide death certificate, medical records, and claim form", timeframe: "Within 60 days" },
          { step_number: 3, title: "Claim Review", description: "We review and verify all documents", timeframe: "14-21 days" },
          { step_number: 4, title: "Payment", description: "Benefit paid to beneficiaries", timeframe: "7-10 days after approval" }
        ],
        terms: "Full terms and conditions apply. Policy subject to underwriting approval. Premium rates may vary based on health assessment."
      }
    ],
    insurance_coverage_list: [],
    exclusions: [],
    eligibility_criteria: [],
    claim_process_steps: [],
    terms: ""
  },

  // Health Insurance Policy (General Insurance)
  {
    id: 2,
    policy_name: "Family Health Plus Insurance",
    slug: "family-health-plus-insurance",
    short_description: "general_insurance",
    insurance_type: "general_insurance",
    policy_type: "health_insurance",
    description: "Comprehensive health insurance coverage for you and your family. Covers hospitalization, outpatient services, surgery, and emergency medical care. Access to a wide network of hospitals and clinics across Ghana.",
    status: "approved",
    max_claims: 5,
    waiting_period: 30,
    geography: "National",
    provider_name: "HealthCare Insurance Co.",
    provider_email: "support@healthcareins.com",
    submitted_date: "2025-12-15T14:20:00Z",
    approved_date: "2025-12-20T09:15:00Z",
    created_at: "2025-12-15T14:20:00Z",
    updated_at: "2025-12-20T09:15:00Z",
    coverage_durations: [
      {
        product_name: "Individual Plan",
        description: "Comprehensive health coverage for one person",
        duration: "1 year",
        premium: 2400,
        premium_duration: "year",
        insurance_coverage_list: [
          { title: "Hospitalization", description: "Full coverage for hospital stays", limit: 50000 },
          { title: "Outpatient Services", description: "Doctor visits and consultations", limit: 10000 },
          { title: "Surgery & Procedures", description: "Coverage for surgical operations", limit: 100000 },
          { title: "Emergency Care", description: "24/7 emergency medical services", limit: 30000 },
          { title: "Prescription Drugs", description: "Coverage for prescribed medications", limit: 15000 }
        ],
        exclusions: [
          "Cosmetic procedures",
          "Pre-existing conditions (first 12 months)",
          "Dental and optical care",
          "Alternative medicine treatments"
        ],
        eligibility_criteria: [
          "Age between 18-70 years",
          "Resident of Ghana",
          "Complete health declaration form"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Seek Treatment", description: "Visit any network hospital or clinic", timeframe: "Immediate" },
          { step_number: 2, title: "Submit Claim", description: "Submit claim form with medical reports", timeframe: "Within 30 days" },
          { step_number: 3, title: "Processing", description: "Claim verification and processing", timeframe: "7-10 days" },
          { step_number: 4, title: "Reimbursement", description: "Payment of approved amount", timeframe: "3-5 days after approval" }
        ],
        terms: "Terms and conditions apply. Network hospitals provide cashless treatment."
      },
      {
        product_name: "Family Plan",
        description: "Health coverage for family of up to 4 members",
        duration: "1 year",
        premium: 7200,
        premium_duration: "year",
        insurance_coverage_list: [
          { title: "Hospitalization", description: "Full coverage for hospital stays", limit: 200000 },
          { title: "Outpatient Services", description: "Doctor visits and consultations", limit: 40000 },
          { title: "Surgery & Procedures", description: "Coverage for surgical operations", limit: 300000 },
          { title: "Emergency Care", description: "24/7 emergency medical services", limit: 100000 },
          { title: "Prescription Drugs", description: "Coverage for prescribed medications", limit: 50000 },
          { title: "Maternity Care", description: "Pre and post-natal care coverage", limit: 75000 }
        ],
        exclusions: [
          "Cosmetic procedures",
          "Pre-existing conditions (first 12 months)",
          "Dental and optical care (unless specified)",
          "Alternative medicine treatments"
        ],
        eligibility_criteria: [
          "Primary member age between 18-70 years",
          "Dependents under 21 years or students under 25",
          "All members must be Ghana residents",
          "Complete health declaration for all members"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Seek Treatment", description: "Visit any network hospital or clinic", timeframe: "Immediate" },
          { step_number: 2, title: "Submit Claim", description: "Submit claim form with medical reports", timeframe: "Within 30 days" },
          { step_number: 3, title: "Processing", description: "Claim verification and processing", timeframe: "7-10 days" },
          { step_number: 4, title: "Reimbursement", description: "Payment of approved amount", timeframe: "3-5 days after approval" }
        ],
        terms: "Family plan covers spouse and up to 3 children. Additional members require extra premium."
      }
    ],
    insurance_coverage_list: [],
    exclusions: [],
    eligibility_criteria: [],
    claim_process_steps: [],
    terms: ""
  },

  // Home Insurance Policy (General Insurance)
  {
    id: 3,
    policy_name: "HomeSafe Property Insurance",
    slug: "homesafe-property-insurance",
    short_description: "general_insurance",
    insurance_type: "general_insurance",
    policy_type: "home_insurance",
    description: "Comprehensive home insurance protecting your property and belongings against fire, theft, natural disasters, and other risks. Includes building structure, contents, and third-party liability coverage.",
    status: "rejected",
    max_claims: 3,
    waiting_period: 14,
    geography: "National",
    provider_name: "PropertyShield Insurance",
    provider_email: "info@propertyshield.gh",
    submitted_date: "2026-01-05T11:45:00Z",
    rejected_date: "2026-01-08T16:30:00Z",
    rejection_reason: "Insufficient documentation provided. Please resubmit with complete property valuation report and proof of ownership.",
    created_at: "2026-01-05T11:45:00Z",
    updated_at: "2026-01-08T16:30:00Z",
    coverage_durations: [
      {
        product_name: "Standard Home Cover",
        description: "Essential protection for your home and contents",
        duration: "1 year",
        premium: 3600,
        premium_duration: "year",
        insurance_coverage_list: [
          { title: "Building Structure", description: "Coverage for the physical structure", limit: 500000 },
          { title: "Contents Coverage", description: "Protection for household items", limit: 200000 },
          { title: "Fire & Lightning", description: "Damage from fire and lightning", limit: 500000 },
          { title: "Theft & Burglary", description: "Loss due to theft or break-in", limit: 100000 }
        ],
        exclusions: [
          "Wear and tear",
          "Intentional damage",
          "War and nuclear risks",
          "Unoccupied property for more than 30 days"
        ],
        eligibility_criteria: [
          "Property owner or tenant with insurable interest",
          "Property in good structural condition",
          "Residential use only"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Report Incident", description: "Notify us and file police report if applicable", timeframe: "Within 48 hours" },
          { step_number: 2, title: "Assessment", description: "Our assessor will inspect the damage", timeframe: "3-5 days" },
          { step_number: 3, title: "Documentation", description: "Submit all required documents and photos", timeframe: "Within 7 days" },
          { step_number: 4, title: "Settlement", description: "Claim payment or repair authorization", timeframe: "10-14 days after approval" }
        ],
        terms: "Property must be maintained in good condition. Security measures required."
      }
    ],
    insurance_coverage_list: [],
    exclusions: [],
    eligibility_criteria: [],
    claim_process_steps: [],
    terms: ""
  },

  // Travel Insurance Policy - Daily Commuter
  {
    id: 4,
    policy_name: "Daily Commuter Safety Plan",
    slug: "daily-commuter-safety-plan",
    short_description: "travel_insurance",
    insurance_type: "travel_insurance",
    policy_type: "daily_commuter",
    description: "Affordable daily commuter insurance for people who travel regularly within the city. Covers accidents during daily commute to work, school, or regular destinations within Greater Accra.",
    status: "pending",
    max_claims: 10,
    waiting_period: 7,
    geography: "Greater Accra",
    provider_name: "CommuteSecure Ltd",
    provider_email: "care@commutesecure.gh",
    submitted_date: "2026-01-12T08:15:00Z",
    created_at: "2026-01-12T08:15:00Z",
    updated_at: "2026-01-12T08:15:00Z",
    coverage_durations: [
      {
        product_name: "Monthly Commuter Pass",
        description: "30-day coverage for daily commuters",
        duration: "30 days",
        premium: 45,
        premium_duration: "month",
        insurance_coverage_list: [
          { title: "Accidental Death", description: "Coverage in case of fatal accident", limit: 50000 },
          { title: "Medical Expenses", description: "Emergency medical treatment", limit: 20000 },
          { title: "Disability Benefit", description: "Permanent disability compensation", limit: 75000 },
          { title: "Ambulance Services", description: "Emergency ambulance transport", limit: 2000 }
        ],
        exclusions: [
          "Accidents outside designated routes",
          "Self-inflicted injuries",
          "Accidents while under influence of alcohol/drugs",
          "Accidents during illegal activities"
        ],
        eligibility_criteria: [
          "Age between 16-70 years",
          "Regular commuter in Greater Accra",
          "Valid identification"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Emergency Response", description: "Call emergency number immediately", timeframe: "Immediate" },
          { step_number: 2, title: "File Report", description: "Submit accident report and police statement", timeframe: "Within 48 hours" },
          { step_number: 3, title: "Medical Documentation", description: "Provide medical reports and bills", timeframe: "Within 14 days" },
          { step_number: 4, title: "Claim Payment", description: "Reimbursement of approved expenses", timeframe: "7-10 days after approval" }
        ],
        terms: "Coverage valid for travel within designated commuter routes only."
      },
      {
        product_name: "Annual Commuter Plus",
        description: "365-day coverage with enhanced benefits",
        duration: "1 year",
        premium: 480,
        premium_duration: "year",
        insurance_coverage_list: [
          { title: "Accidental Death", description: "Coverage in case of fatal accident", limit: 100000 },
          { title: "Medical Expenses", description: "Emergency medical treatment", limit: 50000 },
          { title: "Disability Benefit", description: "Permanent disability compensation", limit: 150000 },
          { title: "Ambulance Services", description: "Emergency ambulance transport", limit: 5000 },
          { title: "Daily Hospital Cash", description: "Cash benefit during hospitalization", limit: 10000 }
        ],
        exclusions: [
          "Accidents outside designated routes",
          "Self-inflicted injuries",
          "Accidents while under influence of alcohol/drugs",
          "Accidents during illegal activities"
        ],
        eligibility_criteria: [
          "Age between 16-70 years",
          "Regular commuter in Greater Accra",
          "Valid identification",
          "No pre-existing major medical conditions"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Emergency Response", description: "Call emergency number immediately", timeframe: "Immediate" },
          { step_number: 2, title: "File Report", description: "Submit accident report and police statement", timeframe: "Within 48 hours" },
          { step_number: 3, title: "Medical Documentation", description: "Provide medical reports and bills", timeframe: "Within 14 days" },
          { step_number: 4, title: "Claim Payment", description: "Reimbursement of approved expenses", timeframe: "7-10 days after approval" }
        ],
        terms: "Coverage valid for travel within designated commuter routes only. Automatic renewal available."
      }
    ],
    insurance_coverage_list: [],
    exclusions: [],
    eligibility_criteria: [],
    claim_process_steps: [],
    terms: ""
  },

  // Intercity Travel Insurance
  {
    id: 5,
    policy_name: "Intercity Travel Protection",
    slug: "intercity-travel-protection",
    short_description: "travel_insurance",
    insurance_type: "travel_insurance",
    policy_type: "intercity_travel",
    description: "Comprehensive insurance for travelers going between cities and regions. Coverage for accidents, delays, and emergencies during intercity journeys across Ghana and neighboring countries.",
    status: "pending",
    max_claims: 8,
    waiting_period: 0,
    geography: "West Africa",
    provider_name: "TravelSafe Insurance",
    provider_email: "hello@travelsafe.com.gh",
    submitted_date: "2026-01-11T13:00:00Z",
    created_at: "2026-01-11T13:00:00Z",
    updated_at: "2026-01-11T13:00:00Z",
    coverage_durations: [
      {
        route_type: "regional",
        route_destination: "Eastern Region",
        display_value: "4",
        display_unit: "hours",
        price: 25,
        duration: "4 hours"
      },
      {
        route_type: "regional",
        route_destination: "Ashanti Region",
        display_value: "5",
        display_unit: "hours",
        price: 30,
        duration: "5 hours"
      },
      {
        route_type: "regional",
        route_destination: "Northern Region",
        display_value: "12",
        display_unit: "hours",
        price: 50,
        duration: "12 hours"
      },
      {
        route_type: "international",
        route_destination: "Togo",
        display_value: "6",
        display_unit: "hours",
        price: 75,
        duration: "6 hours"
      },
      {
        route_type: "international",
        route_destination: "Burkina Faso",
        display_value: "18",
        display_unit: "hours",
        price: 120,
        duration: "18 hours"
      }
    ],
    insurance_coverage_list: [
      { title: "Accidental Death", description: "Coverage during journey", limit: 150000 },
      { title: "Medical Expenses", description: "Emergency medical care en route", limit: 75000 },
      { title: "Trip Delay", description: "Compensation for significant delays", limit: 5000 },
      { title: "Lost Luggage", description: "Coverage for lost or damaged baggage", limit: 10000 }
    ],
    exclusions: [
      "Travel to war zones or conflict areas",
      "Pre-existing medical emergencies",
      "Illegal border crossings",
      "Delays due to personal reasons"
    ],
    eligibility_criteria: [
      "Valid travel documents",
      "Age between 5-75 years",
      "Travel on registered/licensed transport"
    ],
    claim_process_steps: [
      { step_number: 1, title: "Incident Report", description: "Report incident to transport operator and insurer", timeframe: "Within 24 hours" },
      { step_number: 2, title: "Documentation", description: "Submit ticket, medical/police reports as applicable", timeframe: "Within 5 days" },
      { step_number: 3, title: "Assessment", description: "Claim evaluation and verification", timeframe: "5-7 days" },
      { step_number: 4, title: "Payment", description: "Settlement of approved claim", timeframe: "3-5 days after approval" }
    ],
    terms: "Coverage valid only for the specific journey. Single trip coverage."
  },

  // Okada Rider Insurance
  {
    id: 6,
    policy_name: "Moto Rider Protection Plan",
    slug: "moto-rider-protection-plan",
    short_description: "travel_insurance",
    insurance_type: "travel_insurance",
    policy_type: "okada_rider",
    description: "Specialized insurance for motorcycle taxi riders providing comprehensive coverage for accidents and injuries on the job. Designed specifically for commercial motorcycle operators.",
    status: "approved",
    max_claims: 15,
    waiting_period: 3,
    geography: "National",
    provider_name: "RiderGuard Insurance",
    provider_email: "support@riderguard.gh",
    submitted_date: "2025-12-28T09:30:00Z",
    approved_date: "2026-01-02T14:20:00Z",
    created_at: "2025-12-28T09:30:00Z",
    updated_at: "2026-01-02T14:20:00Z",
    coverage_durations: [
      {
        product_name: "Monthly Rider Cover",
        description: "30-day protection for motorcycle riders",
        duration: "30 days",
        premium: 120,
        premium_duration: "month",
        insurance_coverage_list: [
          { title: "Accidental Death", description: "Fatal accident compensation", limit: 200000 },
          { title: "Medical Treatment", description: "Hospitalization and treatment", limit: 100000 },
          { title: "Permanent Disability", description: "Loss of limb or function", limit: 250000 },
          { title: "Temporary Disability", description: "Weekly income during recovery", limit: 30000 },
          { title: "Emergency Transport", description: "Ambulance and emergency services", limit: 5000 }
        ],
        exclusions: [
          "Riding without valid license",
          "Accidents while intoxicated",
          "Racing or stunt activities",
          "Unregistered motorcycles"
        ],
        eligibility_criteria: [
          "Age between 18-60 years",
          "Valid motorcycle license",
          "Registered commercial motorcycle",
          "Clean driving record"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Emergency Call", description: "Contact emergency hotline immediately", timeframe: "Immediate" },
          { step_number: 2, title: "Police Report", description: "File accident report with police", timeframe: "Within 24 hours" },
          { step_number: 3, title: "Medical Records", description: "Submit medical documentation and bills", timeframe: "Within 7 days" },
          { step_number: 4, title: "Claim Processing", description: "Review and verification", timeframe: "7-10 days" },
          { step_number: 5, title: "Payment", description: "Disbursement of benefits", timeframe: "5 days after approval" }
        ],
        terms: "Valid for registered commercial motorcycle riders. Proof of license and registration required."
      }
    ],
    insurance_coverage_list: [],
    exclusions: [],
    eligibility_criteria: [],
    claim_process_steps: [],
    terms: ""
  },

  // Accident Insurance (General Insurance)
  {
    id: 7,
    policy_name: "Personal Accident Shield",
    slug: "personal-accident-shield",
    short_description: "general_insurance",
    insurance_type: "general_insurance",
    policy_type: "accident_insurance",
    description: "24/7 personal accident insurance providing financial protection against accidental injuries, disability, and death. Coverage applies anywhere, anytime for work and leisure activities.",
    status: "approved",
    max_claims: 5,
    waiting_period: 0,
    geography: "Worldwide",
    provider_name: "AccidentCare Insurance",
    provider_email: "claims@accidentcare.gh",
    submitted_date: "2025-12-01T10:00:00Z",
    approved_date: "2025-12-05T16:45:00Z",
    created_at: "2025-12-01T10:00:00Z",
    updated_at: "2025-12-05T16:45:00Z",
    coverage_durations: [
      {
        product_name: "Individual Protection",
        description: "Comprehensive accident cover for one person",
        duration: "1 year",
        premium: 1800,
        premium_duration: "year",
        insurance_coverage_list: [
          { title: "Accidental Death Benefit", description: "Lump sum payment to beneficiaries", limit: 500000 },
          { title: "Permanent Total Disability", description: "Complete loss of function", limit: 500000 },
          { title: "Permanent Partial Disability", description: "Partial loss of function", limit: 300000 },
          { title: "Medical Expenses", description: "Treatment costs for injuries", limit: 150000 },
          { title: "Hospital Daily Cash", description: "Daily allowance during hospitalization", limit: 20000 }
        ],
        exclusions: [
          "Intentional self-injury",
          "Injuries from criminal acts",
          "War and terrorism",
          "Extreme sports (unless specified)",
          "Pre-existing conditions"
        ],
        eligibility_criteria: [
          "Age between 18-70 years",
          "No current major disability",
          "Resident or regular visitor to Ghana"
        ],
        claim_process_steps: [
          { step_number: 1, title: "Notify Insurer", description: "Report accident within 48 hours", timeframe: "Within 48 hours" },
          { step_number: 2, title: "Seek Medical Care", description: "Get treatment from registered facility", timeframe: "Immediate" },
          { step_number: 3, title: "Submit Documents", description: "Claim form, medical reports, police report", timeframe: "Within 30 days" },
          { step_number: 4, title: "Assessment", description: "Medical and claim assessment", timeframe: "10-15 days" },
          { step_number: 5, title: "Settlement", description: "Payment of approved claim", timeframe: "7 days after approval" }
        ],
        terms: "24/7 worldwide coverage. Medical treatment must be from licensed facilities."
      }
    ],
    insurance_coverage_list: [],
    exclusions: [],
    eligibility_criteria: [],
    claim_process_steps: [],
    terms: ""
  }
];

// Helper function to get policy by ID
export const getPolicyById = (id) => {
  return mockPolicies.find(policy => policy.id === parseInt(id));
};

// Helper function to get policy by slug
export const getPolicyBySlug = (slug) => {
  return mockPolicies.find(policy => policy.slug === slug);
};

// Helper function to get policies by status
export const getPoliciesByStatus = (status) => {
  if (!status) return mockPolicies;
  return mockPolicies.filter(policy => policy.status === status);
};

// Helper function to get policy statistics
export const getPolicyStats = () => {
  return {
    total: mockPolicies.length,
    pending: mockPolicies.filter(p => p.status === 'pending').length,
    approved: mockPolicies.filter(p => p.status === 'approved').length,
    rejected: mockPolicies.filter(p => p.status === 'rejected').length,
  };
};
